module.exports = __webpack_public_path__ + "img/ski-boot-ski.81238502.svg";